var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkdinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4186 17.2626L17.4226 17.2619V11.1975C17.4226 8.23068 16.7932 5.94531 13.3751 5.94531C11.7319 5.94531 10.6292 6.86029 10.179 7.72772H10.1315V6.22229H6.89062V17.2619H10.2653V11.7955C10.2653 10.3562 10.5342 8.96446 12.2907 8.96446C14.0215 8.96446 14.0473 10.607 14.0473 11.8878V17.2626H17.4186Z",
    fill: "#171618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.39258 6.21875H4.7713V17.2584H1.39258V6.21875Z",
    fill: "#171618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08189 0.726562C2.00159 0.726562 1.125 1.61605 1.125 2.71223C1.125 3.8084 2.00159 4.71649 3.08189 4.71649C4.16218 4.71649 5.03877 3.8084 5.03877 2.71223C5.03809 1.61605 4.1615 0.726562 3.08189 0.726562Z",
    fill: "#171618"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/linkdin-icon.4f89bab4de5c2fab24fc1866d29bc19e.svg";
export { ForwardRef as ReactComponent };